const postCierreDeTurno = async cierreDeTurno => {
  localStorage.setItem("totalTransferencias", "0");
  localStorage.setItem("transferencias", "[]");
  return "El cierre se ha efectuado exitosamente.";
};

const cierreDeTurno = {
  postCierreDeTurno,
};

export default cierreDeTurno;
